<template>
  <section class="resource-box">
    <iframe
      class="iframe-box"
      src="https://zsparkweb.jianshankeji.com/ptzy/"
      frameborder="0"
    ></iframe>
    <bottomNav :choose="2"></bottomNav>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  },

  components: {},

  mounted() {},

  methods: {},
};
</script>
<style lang='scss' scoped>
.resource-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  .iframe-box {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    z-index: -1;
  }
}
</style>